import HuddleNotes from './HuddleNotes';
export default HuddleNotes;